export default "__VITE_ASSET__CcxKfgrn__"